.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.refreshAction {
  display: flex;
  justify-content: end;
  gap: var(--spacingMd);
  align-items: center;
}

.header {
  display: inline-block;
  color: var(--paletteBlack1);

  &::first-letter {
    text-transform: uppercase;
  }
}
